export default __webpack_public_path__ + "static/media/card-sort-01.456ac135.jpg";